<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-plane"></i>
                <strong> Ingreso despacho</strong>
                <div class="card-header-actions">
                    <small class="text-muted">
                    <select-scale></select-scale>
                    </small>
                </div>
              </div>

              <form-wizard
                color="#20a8d8"
                ref="wizard"
                errorColor="#f86c6b"
                title=""
                subtitle=""
                next-button-text="Siguiente"
                back-button-text="Atrás"
                finish-button-text="Terminar"
                @on-complete="onComplete"
              >
                <wizard-step
                  slot-scope="props"
                  slot="step"
                  :tab="props.tab"
                  :transition="props.transition"
                  :index="props.index"
                ></wizard-step>

                <tab-content title="Información del documento" :before-change="submitWaybill">
                  <b-card-body>
                    <b-row>
                      <b-col sm="6">
                        <b-form-group description label="Exportadora">
                          <b-form-select
                            v-model="waybillData.client_customer"
                            :state="$v.waybillData.client_customer.$dirty ? !$v.waybillData.client_customer.$error : null"
                            aria-describedby="input-exportadora-live-feedback"
                          >
                            <option value>Seleccione</option>
                            <option
                              v-for="customer in customers"
                              v-bind:value="{ id: customer.value, text: customer.text }"
                            >{{ customer.text }}
                            </option>
                          </b-form-select>
                          <b-form-invalid-feedback id="input-exportadora-live-feedback">
                            <p>Exportadora es requerido</p>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group description label="Destinatario">
                          <v-select
                            :options="companies"
                            v-model="waybillData.company"
                            :state="$v.waybillData.client_customer.$dirty ? !$v.waybillData.client_customer.$error : null"
                            label="text"
                            :reduce="text => text.value"
                            class="style-chooser ">
                            <template #search="{attributes, events}">
                              <input
                                class="vs__search"
                                :required="!selected"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>

                          </v-select>


                          <b-form-invalid-feedback id="input-exportadora-live-feedback">
                            <p>Empresa es requerido</p>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for>Número de guía</label>
                          <b-form-input
                            type="text"
                            v-model="waybillData.numero_guia"
                            :state="$v.waybillData.numero_guia.$dirty ? !$v.waybillData.numero_guia.$error : null"
                            aria-describedby="input-numeroguia-live-feedback"
                            placeholder="Ingrese sólo números"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-numeroguia-live-feedback">
                            <p
                              v-if="!$v.waybillData.numero_guia.required"
                            >Número de guia es requerido</p>
                            <p v-if="!$v.waybillData.numero_guia.numeric">Solo numeros</p>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6">
                        <b-form-group description label="Fecha de guía">
                          <b-form-input
                            v-model="waybillData.waybill_date"
                            :state="$v.waybillData.waybill_date.$dirty ? !$v.waybillData.waybill_date.$error : null"
                            aria-describedby="input-fechaguia-live-feedback"
                            type="date"
                          ></b-form-input>

                          <b-form-invalid-feedback id="input-fechaguia-live-feedback">
                            <p>Fecha guia es requerido</p>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6">
                        <b-form-group description label="Nombre del Chofer">
                          <b-form-input
                            type="text"
                            v-model="waybillData.truck_driver"
                            :state="$v.waybillData.truck_driver.$dirty ? !$v.waybillData.truck_driver.$error : null"
                            aria-describedby="input-nombrechofer-live-feedback"
                          />

                          <b-form-invalid-feedback id="input-nombrechofer-live-feedback">
                            <p>Nombre del Chofer es requerido</p>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <b-col sm="6">
                        <b-form-group description label="Patente">
                          <b-form-input
                            type="text"
                            v-model="waybillData.license_plate"
                            :state="$v.waybillData.license_plate.$dirty ? !$v.waybillData.license_plate.$error : null"
                            aria-describedby="input-patente-live-feedback"
                            placeholder
                          />

                          <b-form-invalid-feedback id="input-patente-live-feedback">
                            <p>Nombre del Chofer es requerido</p>
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <b-col sm="12">
                        <b-form-group description label="Nota">
                          <b-form-textarea
                            id="basicTextarea"
                            :textarea="true"
                            v-model="waybillData.note"
                            type="text"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </tab-content>


                <tab-content title="Datos Exportación" :before-change="submitformDatosExportacion">


                  <formGuiaDespachoExportacion ref="formGuiaDespachoExportacion"
                                               :waybillDataExportacion="waybillDataExportacion"
                                               @loadDateTable="loadDateTable" :readOnly="readOnly">
                  </formGuiaDespachoExportacion>

                </tab-content>

                <tab-content title="Ingresar Pallets" v-if="waybillData.id" :before-change="submitformLoadTable">

                <AddPalletsGuia
                          ref="addpallet"
                          :waybill_id="waybillData.id"
                          :waybill_numero="waybillData.numero_guia"
                          :client_customer="waybillData.client_customer"
                          :tableDataPalletStock="tableDataPalletStock"
                          :waybillDataExportacion="waybillDataExportacion"
                          :exportPallet="exportPallet"
                          :guiaPallets="guiaPallets"
                          :data="data"
                          :palletShipmentData="palletShipmentData"
                          :formExportPalletData="formExportPalletData"
                          @addPalletswaybill="addPalletswaybill"

                        >
                        </AddPalletsGuia>





                  <tablaPalletGuiaExportacion :guiaPallets="guiaPallets" :data="data"
                                              @deletePallet="deletePallet"></tablaPalletGuiaExportacion>


                </tab-content>


                    <tab-content title="Condición de transporte" :before-change="submitformConditionTransport">

                       
                  <FormConditionTransport ref="FormConditionTransport"
                                               :waybill_id="waybillData.id"
                                               :waybillDataConditionTransportExport="waybillDataConditionTransportExport"
                                               >
                  </FormConditionTransport>

                </tab-content>



                 <tab-content title="Datos transporte" :before-change="submitFormDataTransport">

                       
                  <FormDataTransport ref="FormDataTransport"
                                               :waybill_id="waybillData.id"
                                               :waybillDataTransportExport="waybillDataTransportExport"
                                               >
                  </FormDataTransport>

                </tab-content>


                <!-- <tab-content title="Imprimir Despacho" :before-change="tapTerminar">
                  <report v-if="waybill" ref="report" :waybill="waybill"></report>
                </tab-content> -->

              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
  // TODO: Cuando me dirijo a Ingreso desde editar guia, no refresca la pagina ingreso.
  // TODO: El boton de NExt debe permanecer inactiva hasta qeu se rellenen los datos obligatorios.
  // TODO: Pantalla de finalización del proceso con opcion de imprimir, enviar x correo, etc.
  // TODO: Comportamiento de modales; a veces se quedan pegados.

  import {shuffleArray} from "@/shared/utils";

  import {validationMixin} from "vuelidate";

  import {required, numeric} from "vuelidate/lib/validators";


  import formGuiaDespachoExportacion from "./formGuiaDespachoExportacion.vue";
  import AddPalletsGuia from "./addPalletGuiaExportacion.vue";

  import tablaPalletGuiaExportacion from "./tablaPalletGuiaExportacion.vue";
  import FormConditionTransport from "./FormConditionTransport.vue";
  import FormDataTransport from "./FormDataTransport.vue";
  
  //import Report from "../recepcion/Report.vue";

  import axios from "axios";
  import {FormWizard, TabContent} from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";

  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';
  import selectScale from '../../reusable/selectScale'

  import {bus} from "../../../main";

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }

  miniToastr.init({types: toastTypes})


  export default {
    name: "guiaDespachoExportacion",
    components: {
      selectScale,
      FormWizard,
      TabContent,
      formGuiaDespachoExportacion,
      AddPalletsGuia,
      vSelect,
      tablaPalletGuiaExportacion,
      FormConditionTransport,
      FormDataTransport,
      //Report
    },
    mounted() {
      if (this.ExportGuiaID) {
        this.editing = true;
      }


      this.waybillSaved = false;
      this.getCustomers();

      this.waybillData.id = "";
      this.waybillData.numero_guia = "";
      this.waybillData.waybill_date = "";
      this.waybillData.arrival_datetime = "";
      this.waybillData.internal_note = "";
      this.waybillData.truck_driver = "";
      this.waybillData.note = "";
      this.waybillData.license_plate = "";
      this.waybillData.client_customer = "";
      this.waybillData.company = "";

      if (this.ExportGuiaID != null) {

        this.loadWaybill(this.ExportGuiaID);
        this.waybillSaved = true;
        //this.getPalletWaybill();

      }

      this.$barcodeScanner.destroy();

    },
    props: ["ExportGuiaID"],
    data() {
      return {
        editing: false,
        readOnly: false,
        palletShipmentData: [],
        data: [],
        guiaPallets: [],
        waybill: null,
        parent: "",
        validated: false,
        tableDataPalletGuia: [],
        tableDataPalletStock: [],
        kilosBrutosTotales: 0,
        kilosNetosTotales: 0,
        submitStatus: null,
        selected: null, // Must be an array reference!
        waybillSaved: false,
        exportPallet: {
          gross_weight: "",
          temperature: "",
          position: "",
          shipment_type: "",
          temperature_recorder: "",
          client: ","
        },
        formModal: {
          status: false, //False to hide, True to show.
          type: false //False if is a new content, True if there is an axistind content and require edition.
        },
        formExportPalletData: {
          formValidate: false,
        },
        show: true,
        items: [],
        counter: 0,
        // contentEdit is the object selected in child component. Look for props in DetallesRecepcion.vue. There has to be passed to DetalleRecepcionModal.vue, the other child component.
        contentEdit: {},
        waybillData: {
          id: "",
          numero_guia: "",
          waybill_date: "",
          arrival_datetime: "",
          internal_note: "",
          note: "",
          license_plate: "",
          truck_driver: "",
          company: null,
          client_customer: "",
          client: "",
          texto_exportadora: ""
        },
        waybillDataExportacion: {
          shipment: "",
          shipment_type: "",
          vgm: "",
          sag_sheet: "",
          sag_worker: "",
        },
         waybillDataConditionTransportExport: {
          sanitation_certificate: "",
          cold_unit_before_loading: "",
          interior_cleaning: "",
          channels_floor_ventilation: "",
          sealing_and_door_rubber: "",
          drained_liquid_drains: "",
          load_under_the_red_line: "",
          autonomous_energy_equipment: "",
          temperature_set_point: "",
          controlled_atmosphere_curtain: "",
          sealing_with_floorboard_and_pallets: "",
          shipping_stamp: "",
          seal_plant: "",

        },
        waybillDataTransportExport: {
          end_time: null,
          start_time: null,
          driver_name: "",
          tel: "",
          identification_card: "",
          truck_patent: "",
          patent_car: "",
          observations: "",
          responsible: "",
        },
        companies: [],
        customers: [],
        fields: [
          {key: 'pallet_number', label: 'Número', sorteable: true},
          {key: 'product_name', label: 'Producto', sorteable: true},
          {key: 'product_type_name', label: 'Tipo', sorteable: true},
          {key: 'variety_name', label: 'Variedad', sorteable: true},
          {key: 'origin_name', label: 'Origen', sorteable: true},
          {key: 'condition', label: 'Condicion', sorteable: true},
          {key: 'container_name', label: 'Formato/Recip', sorteable: true},
          {key: 'quantity', label: 'Cantidad', sorteable: true},
          {key: 'net_kilograms', label: 'Kg Netos', sorteable: true},
          {key: 'actions', label: ' ', sorteable: true},
        ]
      };
    },
    mixins: [validationMixin],
    validations: {
      waybillData: {
        client_customer: {
          required
        },
        company: {
          required
        },
        numero_guia: {
          required,
          numeric
        },
        waybill_date: {
          required
        },
        truck_driver: {
          required
        },
        license_plate: {
          required
        }
      }
    },
    computed: {},
    watch: {
      'waybillData.client_customer': {
        handler(val) {
          this.getCompanies(this.waybillData.client_customer);
        },
      },
    },
    methods: {
      loadDateTable() {

        if (this.ExportGuiaID != null) {

          this.readOnly = true;


          this.data = [];
          this.palletShipmentData = [];

          this.$axios.get('/api/comex/shipment/shipping_waybill_export_pallets/', {
            params: {
              client: this.$store.getters.user.ID_CLIENTE,
              shipment_id: this.waybillDataExportacion.shipment,
              waybill_id: this.ExportGuiaID,
            }
          })
            .then(res => {


              this.exportPallet.shipment_type = res.data.shipment.shipment_type.id;

              const data = res.data.pallets;
              const items = [];
              const items2 = [];

              for (let key in data) {

                const item = data[key];

                items.push(item)
                items2.push(item)

              }


              const data2 = res.data.pallets_waybill;

              for (let key in data2) {
                const item = data2[key];

                items.push(item)
              }

              this.data = items2;
              this.palletShipmentData = items;

            })
            .catch(error => console.log(errors))


        } else {

          this.readOnly = false;

          this.data = [];
          this.palletShipmentData = [];

          this.$axios.get('/api/comex/shipment/shipping_waybill_export_pallets/', {
            params: {
              client: this.$store.getters.user.ID_CLIENTE,
              shipment_id: this.waybillDataExportacion.shipment,
              waybill_id: 0,
            }
          })
            .then(res => {

              this.exportPallet.shipment_type = res.data.shipment.shipment_type.id;

              const data = res.data.pallets;
              const items = [];
              for (let key in data) {
                const item = data[key];

                items.push(item)
              }

              this.data = items;
              this.palletShipmentData = items;

            })
            .catch(error => console.log(error))


        }


      },
      addPalletswaybill(row) {

          miniToastr.success("Pallets agregado con exito");

          let deleteIndex = this.data.findIndex(
            item => item.number === row.number
          );

          this.data.splice(deleteIndex, 1);
          this.guiaPallets.push(row);

      },

      deletePallet(row) {

        let deleteIndex = this.guiaPallets.findIndex(
          item => item.number === row.number
        );

        this.guiaPallets.splice(deleteIndex, 1);
        this.data.push(row);

      },
      getCompleteWaybill(a) {
        this.$axios.get('/api/v1/waybill/' + a + '/waybill_complete/')
          .then(res => {
            this.waybill = res.data
          })
          .catch(error => console.log(error))
      },
      updateKilosTabla: function () {

        this.kilosBrutosTotales = 0;
        this.kilosNetosTotales = 0;

        for (var indice in this.tableDataPalletGuia) {
          this.kilosBrutosTotales += parseFloat(
            this.tableDataPalletGuia[indice].Kilos_brutos
          );
          this.kilosNetosTotales += parseFloat(
            this.tableDataPalletGuia[indice].Kilos_netos
          );
        }

        return true;
      },
      onComplete() {


      },
      loadWaybill(a) {

        axios.get("/api/comex/export_waybill/specific_detailed/", {
          params: {
            id: a
          }
        })
          .then(res => {


            this.waybillData.id = res.data.data.waybill.id;
            this.waybillData.numero_guia = res.data.data.waybill.number;
            this.waybillData.waybill_date = res.data.data.waybill.waybill_date;
            this.waybillData.arrival_datetime = res.data.data.waybill.arrival_datetime;
            this.waybillData.internal_note = res.data.data.waybill.internal_note;
            this.waybillData.truck_driver = res.data.data.waybill.truck_driver;
            this.waybillData.note = res.data.data.waybill.note;
            this.waybillData.license_plate = res.data.data.waybill.license_plate;
            this.waybillData.client_customer = {
              "id": res.data.data.waybill.client_customer,
              "text": res.data.data.waybill.client_customer_name
            };

            this.waybillData.company = res.data.data.waybill.company;
            this.waybillData.client = res.data.data.waybill.client;


            this.waybillDataExportacion.shipment = res.data.data.shipment.id;
            this.waybillDataExportacion.vgm = res.data.data.vgm;
            this.waybillDataExportacion.sag_sheet = res.data.data.sag_sheet;
            this.waybillDataExportacion.sag_worker = res.data.data.sag_worker.id;


            console.log(res.data.pallets);


            this.data = res.data.pallets;
            this.guiaPallets = res.data.pallets;


          })
          .catch(error => console.log(error));
        console.log(this.waybillData.company)
      },
      getCompanies(a) {
        this.$axios
          .get("/api/comex/export_waybill/companies/")
          .then(res => {
            const data = res.data;
            const companies = [];
            for (let key in data) {
              const company = data[key];
              companies.push(company);
            }
            this.companies = companies;
          })
          .catch(error => console.log("error"));
      },
      getCompaniesEdit(id, texto) {


        axios
          .get(
            "/production/get_companies/" +
            this.waybillData.client_customer.id +
            "/"
          )
          .then(res => {
            const data = res.data.data;
            const companies = [];
            this.waybillData.company = "";

            for (let key in data) {
              const company = data[key];
              companies.push(company);
            }
            this.companies = companies;

            this.waybillData.company = {"id": id, "text": texto};

          })
          .catch(error => console.log("Error"));

      },
      getCustomers() {

        axios
          .get("/production/get_customers/")
          .then(res => {

            const data = res.data.data;
            const customers = [];

            //customers.push({ value: null, text: "Seleccione" });

            for (let key in data) {
              const customer = data[key];
              customers.push(customer);
            }

            this.customers = customers;

          })
          .catch(error => console.log(error));
      },
      getPalletWaybill() {

        axios
          .get("/api/v1/allstock/" + this.waybillID + "/getAllInfoPalletGuia/")
          .then(res => {

            const data = res.data.data;


            if (res.data.status == 1) {
              for (let key in data) {

                var rowNew = {
                  Numero: data[key].number,
                  Kilos_brutos: data[key].total_gross_kilograms,
                  Kilos_netos: data[key].total_net_kilograms,
                  id_pallet: data[key].id,
                  total_contents: data[key].total_contents,
                  contents_data: data[key].contents
                };


              }
              this.addPalletswaybill(rowNew);

            }

          })
          .catch(error => console.log(error));
      },
      openEditModal(data) {
        this.contentEdit = data;
        // Set formModal.type to true to tell the modal that is a update modal.
        this.formModal.type = true;
        // Use ref to run child methods.
        this.$refs.modals.loadEdit(data);
        this.formModal.status = true;
      },
      changeVerification: async () => {


        const formData = {
          number: parent.waybillData.numero_guia,
          waybill_date: parent.waybillData.waybill_date,
          arrival_datetime: null,
          internal_note: parent.waybillData.internal_note,
          note: parent.waybillData.note,
          license_plate: parent.waybillData.license_plate,
          truck_driver: parent.waybillData.truck_driver,
          company: parent.waybillData.company,
          client_customer: parent.waybillData.client_customer.id,
          waybill_type: 2,
          client: parent.$store.getters.user.ID_CLIENTE,
        };


        if (parent.waybillSaved === false) {


          try {

            const res = await parent.$axios
              .post("/api/v1/waybill/", formData)
              .then(res => {
                miniToastr.success("Guía creada con éxito", "");
                parent.waybillData.id = res.data.id;
                parent.waybillSaved = true;
                parent.validated = true;
              })
              .catch(function (error) {

                parent.$swal.fire(
                  error.response.data.non_field_errors[0],
                  "",
                  "warning"
                );

                parent.validated = false;

              });


          } catch (err) {
            console.error("error" + err);
          }


        } else {

          try {

            const res = await parent.$axios
              .put(
                "/api/v1/waybill/" +
                parent.waybillData.id +
                "/",
                formData
              )
              .then(res => {
                miniToastr.success("Guía actualizada con éxito", "");
                parent.waybillData.id = res.data.id;
                parent.validated = true;
              })
              .catch(function (error) {

                parent.$swal.fire(
                  error.response.data.non_field_errors[0],
                  "",
                  "warning"
                );

                parent.validated = false;

              });


          } catch (err) {
            console.error("erroor" + err);
          }

        }

        return parent.validated;

      },
      submitWaybill() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.submitStatus = "ERROR";
          //  console.log('ERROR')

          this.$swal.fire(
            "Campos requeridos o invalidos en el formulario",
            "",
            "warning"
          );

          return false;

        } else {

          parent = this;

          return this.changeVerification();


        }


      },
      submitformDatosExportacion() {

        var formGuiaDespachoExportacion = this.$refs.formGuiaDespachoExportacion.saveForm();

        if (formGuiaDespachoExportacion == 0) {

          this.$swal.fire(
            "Campos requeridos o invalidos en el formulario",
            "",
            "warning"
          );
          return false;

        } else {


          const formData = {
            waybill: this.waybillData.id,
            shipment: this.waybillDataExportacion.shipment,
            vgm: this.waybillDataExportacion.vgm,
            sag_sheet: this.waybillDataExportacion.sag_sheet,
            sag_worker: this.waybillDataExportacion.sag_worker,
            client: this.$store.getters.user.ID_CLIENTE,
          };


          if (this.ExportGuiaID != null) {


            this.$axios.put('/api/comex/export_waybill/' + this.waybillData.id +
              '/', formData)
              .then(res => {


                miniToastr.success("Datos actualizados con exito...", "");


              })
              .catch(error => {

                this.$swal.fire(
                  "Problemas al guardar los datos de exportacion",
                  "",
                  "error"
                );
                return false;
              });

          } else {


            this.$axios.post('/api/comex/export_waybill/', formData)
              .then(res => {
                this.ExportGuiaID = res.data.waybill;
                miniToastr.success("Datos cargados con exito...", "");
              })
              .catch(error => {

                this.$swal.fire(
                  "Problemas al guardar los datos de exportacion",
                  "",
                  "error"
                );
                return false;

              });


          }


          return true;


        }


      },
      tapSiguiente() {

        if (this.items && this.items.length) {
          this.getCompleteWaybill(this.waybillData.id);
          return true;
        } else {
          this.$swal.fire(
            "Debe agregar por lo menos un pallet en la guia",
            "",
            "warning"
          );

          return false;
        }
      },
      submitformLoadTable() {
       
        if (this.guiaPallets && this.guiaPallets.length) {

              var methodHttp = "";

              if (this.editing) {

                methodHttp = 1;

                const formData = {
                        waybill_id: this.waybillData.id,
                        methodHttp: methodHttp,
                        shipment_type: this.waybillDataExportacion.shipment_type,
                        pallets: this.guiaPallets,
                        client: this.$store.getters.user.ID_CLIENTE,
                      };
                      this.$axios.put('/api/comex/export_waybill/save_pallet_waybill/', formData)
                        .then(res => {
                        miniToastr.success("Datos cargados con exito...", "");
                        }).catch(error => {
                        this.$swal.fire(
                          "Problemas al guardar los datos",
                          "",
                          "error"
                        );
                        return false;
                      });


              } else {

                methodHttp = 0;

                  const formData = {
                        waybill_id: this.waybillData.id,
                        methodHttp: methodHttp,
                        shipment_type: this.waybillDataExportacion.shipment_type,
                        pallets: this.guiaPallets,
                        client: this.$store.getters.user.ID_CLIENTE,
                      };
                      this.$axios.put('/api/comex/export_waybill/save_pallet_waybill/', formData)
                        .then(res => {
                        miniToastr.success("Datos actualizados con exito...", "");
                        }).catch(error => {
                        this.$swal.fire(
                          "Problemas al guardar los datos",
                          "",
                          "error"
                        );
                        return false;
                      });

              }

      
            this.$refs.FormConditionTransport.loadDataForm();
          return true;
        } else {
          this.$swal.fire(
            "Debe agregar por lo menos un pallet en la guia",
            "",
            "warning"
          );
          return false;
        }


      },
          submitformConditionTransport() {

                const formData = {
                        waybill_id: this.waybillData.id,
                        dataConditionTransportExport: this.waybillDataConditionTransportExport
                      };
                      this.$axios.post('/api/comex/export_waybill/save_condition_transport_export/', formData)
                        .then(res => {
                          if(res.data.status==1){

                            miniToastr.success("Operación realizada con éxito", "");


                          }else{

                            miniToastr.error("Problemas al realizar la operación", "");


                          }
                        
                        }).catch(error => {
                        this.$swal.fire(
                          "Problemas al guardar los datos",
                          "",
                          "error"
                        );
                        return false;
                      });


          this.$refs.FormDataTransport.loadDataForm();
          return true;

      },
       submitFormDataTransport() {


            this.$swal
            .fire({
              title: "Seguro que quieres realizar esta operación?",
              text: "",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#20a8d8",
              cancelButtonColor: "#f86c6b",
              cancelButtonText: "No",
              confirmButtonText: "SI"
            })
            .then(result => {
              if (result.value) {

                 this.waybillDataTransportExport.end_time= this.waybillDataTransportExport.end_time == "" ? null  : this.waybillDataTransportExport.end_time;
                 this.waybillDataTransportExport.start_time= this.waybillDataTransportExport.start_time == "" ? null  : this.waybillDataTransportExport.start_time;
 
                const formData = {
                        waybill_id: this.waybillData.id,
                        waybillDataTransportExport: this.waybillDataTransportExport
                      };
                      this.$axios.post('/api/comex/export_waybill/save_data_transport_export/', formData)
                        .then(res => {
                          if(res.data.status==1){

                            
                             this.$swal.fire("Operacion realizada con éxito", "", "success");
                             this.$router.push("/exportacion/lista-guia-exportacion/");

                          }else{

                            miniToastr.error("Problemas al realizar la operación", "");


                          }
                        
                        }).catch(error => {
                        this.$swal.fire(
                          "Problemas al guardar los datos",
                          "",
                          "error"
                        );
                        return false;
                      });

               


              }
            }); 

                

          
          return true;

      },
    },
  };
</script>


<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    /*display: inline-block;*/
    /*width: 100%;*/
    min-height: calc(1.5em + 0.75rem + 2px);
    /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
    font-size: 0.6875rem;
    font-weight: 400;
    /*line-height: 1.5;*/
    color: #5c6873;
    /*vertical-align: middle;*/
    /*background-color: #fff;*/
    border: 1px solid #e4e7ea;
    /*border-radius: 0.25rem;*/
    /*-webkit-appearance: none;*/

  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }
</style>
